import { useEffect, useRef } from 'react';
import { useU2000WebSocketContext } from '../../../../u2000Core/context/websocket/U2000WebSocketContext';
import {
  isU3141PlanUploadProgressMessage,
  U3141_PLAN_UPLOAD_PROGRESS_WS_EVENT,
  type U3141PlanUploadProgressWsMessage,
} from '../../../../u2000Core/types/U2000WebSocketMessages';
import {
  u3141ShouldHandlePlanUploadProgress,
  type U3141PlanUploadProgressWatchContext,
} from '../../../tools/u3141PlanUploadProgressState';

export type U3141UsePlanUploadProgressNotificationOptions = {
  watchContext: U3141PlanUploadProgressWatchContext;
  onProgress: (payload: U3141PlanUploadProgressWsMessage) => void;
};

/**
 * Écoute `u3141:planUploadProgress` (BL-0603) et filtre par master + clientRequestUuid du mint.
 */
export function useU3141PlanUploadProgressNotification(
  options: U3141UsePlanUploadProgressNotificationOptions
): void {
  const { watchContext, onProgress } = options;
  const { on, off } = useU2000WebSocketContext();
  const onProgressRef = useRef(onProgress);
  onProgressRef.current = onProgress;
  const watchContextRef = useRef(watchContext);
  watchContextRef.current = watchContext;

  useEffect(() => {
    const handleMessage = (message: unknown) => {
      if (!isU3141PlanUploadProgressMessage(message)) {
        return;
      }
      if (!u3141ShouldHandlePlanUploadProgress(message, watchContextRef.current)) {
        return;
      }
      onProgressRef.current(message);
    };

    on(U3141_PLAN_UPLOAD_PROGRESS_WS_EVENT, handleMessage);
    return () => off(U3141_PLAN_UPLOAD_PROGRESS_WS_EVENT, handleMessage);
  }, [on, off]);
}
